import React, {Component} from 'react';
import {Button, Icon} from 'antd';


import './ReadMore.css';

class ReadMore extends Component {
  constructor(props) {
    super(props);

    this.state = {
      expanded: false
    }
  }

  handleClick() {
    this.setState({expanded: !this.state.expanded});
  }

  render() {
    return (
      <div className='ReadMore'>
        <div className={'expander ' + (this.state.expanded ? 'expanded' : 'collapsed')}>
          {this.props.children}
        </div>
        <Button className="toggle" size="small" type="dashed"
                onClick={this.handleClick.bind(this)}>
          <Icon type={this.state.expanded ? 'up' : 'down'}/>
          <span>{this.state.expanded ? 'Less' : 'More'}</span>
        </Button>
      </div>
    );
  }
}

export default ReadMore;


// WEBPACK FOOTER //
// ./src/components/ReadMore.js